<template>
  <div class="custom-fields-component">

    <template  v-for="field of fields">    
      <van-field
        v-if="field.fieldDataType === 5"
        :key="field.customFieldId"
        :required="Boolean(field.required)"
        :input-align="inputAlign"
        :label="field.fieldName"
        :right-icon="showFieldArrow ? 'arrow':''"
        readonly
        placeholder="请选择"
        @click="selectMultFildClick(field)"
      >
        <template #input>
          <div v-if="field.valueList && field.valueList.length" style="color: var(--g8)">
            {{getCustomSelectedStr(field)}}
          </div>
          <div v-else style="color: var(--g5)">{{showModel? '-':'请选择'}}</div>
        </template>
      </van-field>
 
      <van-field
        v-else-if="field.fieldDataType === 4"
        :key="field.customFieldId"
        :required="Boolean(field.required)"
        :input-align="inputAlign"
        :label="field.fieldName"
        :right-icon="showFieldArrow ? 'arrow':''"
        readonly
        placeholder="请选择"
        @click="selectFildClick(field)"
      >
        <template #input>
          <div v-if="field.value" style="color: var(--g8)">
            {{getSelectItem(field)}}
          </div>
          <div v-else style="color: var(--g5)">{{showModel? '-':'请选择'}}</div>
        </template>
      </van-field>

      <!-- 日期表单 -->
      <van-field
        v-else-if="field.fieldDataType === 3"
        v-model="field.value"
        :input-align="inputAlign"
        :key="field.customFieldId"
        :required="Boolean(field.required)"
        :label="field.fieldName"
        readonly
        :placeholder="showModel? '-':'请选择'"
        @click="dateFieldClick(field)"
      >
        <!-- :right-icon="showFieldArrow ? 'arrow':''" -->
        <template #right-icon v-if="showFieldArrow">
          <van-icon name="clear" color="var(--g6)" v-if="field.value" @click.stop="field.value = ''"/>
          <van-icon name="arrow" size="var(--fs-lg)" v-else/>
        </template>
      </van-field>
      <!-- input number类型表单 -->
      <van-field
        v-else-if="field.fieldDataType === 2"
        :key="field.customFieldId"
        v-model="field.value"
        :required="Boolean(field.required)"
        :input-align="inputAlign"
        :label="field.fieldName"
        :readonly="readonlyAll"
        type="number"
        :placeholder="showModel? '-':'请输入'"
        @click="fieldClickHanlder(field)"
        :formatter="numberInputFormatter"        
      />
      <!-- input 文本及其它类型表单 -->
      <template v-else>
        <van-field
          v-if="!readonlyAll"          
          :key="field.customFieldId"
          type="textarea"
          rows="1"
          :autosize="{maxHeight: 48}"
          v-model="field.value"
          :required="Boolean(field.required)"
          :input-align="inputAlign"
          :label="field.fieldName"
          :placeholder="showModel? '-':'请输入'"
          @click="fieldClickHanlder(field)"
          maxLength="50"
        />
        <van-cell v-else :key="field.customFieldId + 'f'" title-style="width:100px; flex:0 0 auto" :title="field.fieldName" :value="field.value"/>

      </template>
    </template>

    <!-- ios下有bug,加一层div -->
    <div>
      <van-popup v-model="showDatePopup" position="bottom" :style="{ height: '50%' }" get-container="body">      
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择日期"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="datePopupConfirm"
          @cancel="showDatePopup=false"
        />
      </van-popup>
    </div>

    <van-popup v-model="showSelectPicker" position="bottom" :style="{ height: '50%' }" get-container="body">      
      <van-picker
        title="请选择"
        show-toolbar
        :columns="actions"
        @confirm="onSelect"
        value-key="itemName"
        :default-index="actionsIdx"
        @cancel="showSelectPicker=false"
      />
    </van-popup>

    <van-popup v-model="showMultSelect" position="bottom" :safe-area-inset-bottom="true" @close="closeCustomSelectedPopup" get-container="body">
      <div class="custom-select-wrapper">
        <div 
          v-for="item in currentSelectedList" 
          :key="item.id" class="sel-item van-ellipsis" 
          :class="{selected : isCustomSelected(item.id)}"
          @click.stop="clickCustomSelected(item)">{{item.itemName}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'customFields',
  props: {
    fields: {
      type: Array,
      default () {return []} 
    },
    readonlyAll: {
      type: Boolean,
      default: false
    },
    showFieldArrow: {
      type: Boolean,
      default: true
    },
    inputAlign: {
      type: String,
      default: 'right'
    },
    showModel: {      
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      types: ['text', 'text', 'number', 'text', 'text'],
      placeholders: ['请输入', '请输入', '请输入', '请选择', '请选择', '请选择'],
      showDatePopup: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(new Date().getFullYear() + 10, 0, 1),
      currentDate: new Date(),
      showSelectPicker: false,      
      showMultSelect: false,
      actions: [],
      actionsIdx: -1,
      currentSelectedList: [],
      currentSelectedListValue: [],
    }
  },
  methods: {
    closeCustomSelectedPopup(){
      this._customSelectedRsv(this.currentSelectedListValue);
    },
    isCustomSelected(id){
      return this.currentSelectedListValue.includes(id);
    },
    fieldClickHanlder (field) {
      this.$emit('inputFiedlsClick', field);
    },
    clickCustomSelected(item){
      if (this.currentSelectedListValue.includes(item.id)) {
        this.currentSelectedListValue.splice(this.currentSelectedListValue.indexOf(item.id),1);
      } else {
        this.currentSelectedListValue.push(item.id);
      }
    },    
    selectMultFildClick(field) {
      if (this.readonlyAll) {
        return false
      }
      this.showMultSelect = true;
      this.currentSelectedList = [...field.selectItemList || []];
      this.currentSelectedListValue = [...field.valueList || []].map(id=> +id);
      new Promise(rsv=>{
        this._customSelectedRsv = rsv;
      }).then(list=> {
        field.valueList = [...list];
      })
    },
    selectFildClick (field) {
      if (this.readonlyAll) {
        return false
      }
      this.clickFiled = field;
      this.actions = [...field.selectItemList||[]];
      this.actionsIdx = 0;
      if (field.value) {
        let idx = this.actions.findIndex(v=>v.itemCode == field.value || v.id == field.value);
        this.actionsIdx = idx;
      }
      this.showSelectPicker = true;
    },
    dateFieldClick (field) {
      if (this.readonlyAll) {
        return false
      }
      this.clickFiled = field;
      if (field.value && new Date(field.value.replace(/-/g, '\/'))) {
        this.currentDate = new Date(field.value.replace(/-/g, '\/'));
      } else {
        this.currentDate = new Date();
      }
      this.showDatePopup = true;
    },
    datePopupConfirm (date) {
      this.$set(this.clickFiled, 'value', app.tool.date.formatDatetime(new Date(date), 'yyyy-MM-dd'));
      this.showDatePopup = false;
      this.$emit('selectChange', this.clickFiled);
    },
    onSelect (selectItems) {
      this.$set(this.clickFiled, 'value', selectItems.id || selectItems.itemCode);
      this.showSelectPicker = false;
      this.$emit('selectChange', this.clickFiled);
    },
    getSelectItem ({value, selectItemList}) {
      if (value === null) {
        return ''
      }
      for (let i = 0; i < selectItemList.length; i++) {
        const element = selectItemList[i];
        if (element.id == value || element.itemCode == value) {
          return element.itemName;
        }
      }
      return '';
    },
    getCustomSelectedStr({valueList = [], selectItemList}) {
      return selectItemList.filter(sel=> valueList.some(v=>v == sel.id)).map(sel=>sel.itemName).join('、');
    },
    validate () {
      let { fields, placeholders } = this
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (field.required && !field.value) {
          if (field.fieldDataType === 2 && field.value === 0) {
            continue;
          }
          if (field.fieldDataType == 5 && field.valueList && field.valueList.length > 0) {
            continue;
          }
          this.$toast(`${placeholders[field.fieldDataType]}${field.fieldName}`);
          return false;
        }
        
      }
      return true;
    },
    // 限制价格输入，从根本上避免用户输入不合法数据
    numberInputFormatter(newVal, regx = /^(([\-])|([\-]?[1-9]{1}\d{0,3})|([\-]?0{1}))(\.\d{0,2})?$/) {
      if (regx.test(newVal)) {
        return newVal;
      } else {
        return newVal.split('').slice(0, -1).join('');
      }
    },
  },
}
</script>
<style lang="scss">
.custom-fields-component {
  .van-cell--required.van-field{
    &::before {
      position: static;
      margin-left: calc(var(--gap) * -5);
      margin-right: calc(var(--gap) * 1);
    }
  }
  .van-field__label{
    white-space: nowrap;
  }

}
.custom-select-wrapper {    
  max-height: 70vh;
  overflow: auto;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 8px;
  row-gap: 12px;
  .sel-item {
    text-align: center;
    padding: 8px 4px;
    background: var(--g1);
    color: var(--g8);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    border-radius: 4px;
    &.selected {
      color: var(--c1);
      background: rgba(var(--c1-rgb), 0.12);
    }
  }
}
</style>